"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/InboxList/Item/ActionBtn.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Tooltip = require('web/components/Tooltip');
var _icons = require('../icons');








// Left of the button, so the first row's tooltip isn't clipped by the list.
const TOOLTIP_OFFSET = { left: -6 }

const ActionBtn = ({
  isCompleted,
  onToggle,
  label: labelOverride,
}) => {
  const label = _nullishCoalesce(labelOverride, () => ( (isCompleted ? "Unarchive" : "Archive")))

  // Space and Enter act, as they would on a native button; the row
  // underneath mustn't open.
  const onKeyDown = _react.useCallback.call(void 0, (e) => {
    if (e.key !== ' ' && e.key !== 'Enter') return
    e.preventDefault()
    e.stopPropagation()
    onToggle()
  }, [onToggle])

  return (
    _react2.default.createElement(_Tooltip.HoverTooltip, {
      type: "dark",
      place: "left",
      hideArrow: true,
      showOnFocus: true,
      offset: TOOLTIP_OFFSET,
      className: "inbox-row--action-tip",
      content: _react2.default.createElement(_Tooltip.TooltipHint, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 40}},  label ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}

      , _react2.default.createElement('div', {
        role: "button",
        tabIndex: 0,
        'aria-label': label,
        onClick: onToggle,
        onKeyDown: onKeyDown,
        className: "inbox-row--action inbox-row--action--archive" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}

        ,  isCompleted ? _react2.default.createElement(_icons.UnarchiveIcon, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 50}} ) : _react2.default.createElement(_icons.ArchiveIcon, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 50}} ) 
      )
    )
  )
}

exports. default = ActionBtn
